import { Chip, Grid } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import * as React from "react";
import { getApprovalInfo, getCreatedByInfo, isOpenInfo } from "../../../../Helper/CreateApprovelFunctions";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const ServiceableStatusChip = ({ serviceable }) => {
  return (
    <Grid {...gridContainerProps}>
      <Chip
        key={88889999}
        color="primary"
        variant="outlined"
        label={getCreatedByInfo(serviceable?.createdByName, serviceable?.createdDate)}
        icon={<InfoIcon />}
      />
      {isOpenInfo(serviceable?.acceptedDate, serviceable?.rejectedDate) && (
        <Chip
          key={88889999}
          color="primary"
          variant="outlined"
          label={getApprovalInfo(
            serviceable?.acceptedBy,
            serviceable?.acceptedDate,
            serviceable?.rejectedBy,
            serviceable?.rejectedDate
          )}
          icon={<InfoIcon />}
        />
      )}
    </Grid>
  );
};

export default ServiceableStatusChip;
